<template>
  <div class="showcase" :id="`${showcase}Showcase`">
    <h1>My</h1>
    <h2>{{ showcase }}</h2>

    <div class="dropdown_btns" v-if="isDownload">
      <div class="expandBtn" @click="$emit('expand-all')">
        <p>Expand All</p>
      </div>
      <div class="collapseBtn" @click="$emit('collapse-all')">
        <p>Collapse All</p>
      </div>
    </div>

    <div class="items">
      <ShowcaseItem
        v-for="(item, index) in items"
        :key="index"
        :item="item"
        :isExpanded="item.isExpanded"
        :isDropdown="showcase === 'resume'"
        @toggle-expand="$emit('toggle-expand', item)"
      />
    </div>

    <div v-if="isDownload" class="download" @click="onDownload">
      <h4>Download PDF Version</h4>
      <i class="fas fa-download"></i>
    </div>
  </div>
</template>

<script src="./Showcase.js"></script>
<style src="./Showcase.scss" lang="scss" scoped></style>